// extracted by mini-css-extract-plugin
export default {"actionButtonInDropdown":"team_actionButtonInDropdown__iK6Hb"};